import { useLang } from '@/i18n';
import DialogVideo from '@elem/compCommon/DialogVideo';
import EfDialogYoutube from '@elem/ui/ef-dialog-youtube';
import EfImg from 'elem/ui/ef-img';
import { useRouter } from 'next/router';
import { FC, useState } from 'react';
import css from './index.module.scss';

const IconVideo = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM8.7926 13.7581L13.4382 10.4054C13.7147 10.2059 13.7147 9.79413 13.4382 9.59456L8.7926 6.24188C8.46192 6.00324 8 6.23952 8 6.64733V13.3527C8 13.7605 8.46192 13.9968 8.7926 13.7581Z"
                fill="currentColor"
            />
        </svg>
    );
};
const naYoutube = 'https://www.youtube.com/embed/gtxAkmNxMH8?si=MSicapOQhBWL8Dw-';
const jpYoutube = 'https://www.youtube.com/embed/eEcrRV-GTys?si=uuNs3T1KLKNCoKkX';
const cnAlibaba = '';
// 通用
const TheCompCommon: FC = () => {
    const { t } = useLang('dp3.landing.Banner');
    const { locale = 'us' } = useRouter();
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const [isShow, setIsShow] = useState(false);

    const img = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1720161656308/PC.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1720161668046/1024.jpg',
    };

    const img_eu = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724291757169/DP3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724291758440/M_EU_DP3.jpg',
    };

    const img_cn = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1737772969457/1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1737772969263/1_M.jpg',
    };

    const clickHandle = () => {
        if (locale !== 'cn' || cnAlibaba) {
            setIsShow(true);
        } else {
            window.open('https://mp.weixin.qq.com/s/h_sGnVxlG8Cg7qn_zgAOPA', '_blank');
        }
    };
    const closeCallback = () => {
        setIsShow(false);
    };

    const finalImg = IS_EU_SITES ? img_eu : locale === 'cn' ? img_cn : img;

    return (
        <div
            id="dp3-teaser-A"
            className={`${css.thecomp} dp3-teaser-A dp3-teaser-full GtmModuleData-section`}
            data-section-id={'dp3-Banner'}
            data-section-title={t('title')}
        >
            <div className={`kv-img${IS_EU_SITES ? ' eu' : ''}`}>
                {/* <EditorVideo
                    pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1718805448259/t1.mp4"
                    h5="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1718805484420/t2.mp4"
                    poster="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718864450276/pv1.jpg"
                    posterH5="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718864500277/pv2.jpg"
                    autoPlay={true}
                    loop={true}
                    alt={t('title')}
                /> */}
                <EfImg {...finalImg} />
            </div>
            <div className={`kv-info${IS_EU_SITES ? ' eu' : ''}`}>
                <p className="kv-title">{t('title')}</p>
                {!IS_EU_SITES && <p className="kv-sub-title">{t('subTitle')}</p>}
                <p className="kv-desc">{t('desc')}</p>
                {!IS_EU_SITES && locale !== 'cn' && (
                    <button className="kv-btn-video" onClick={clickHandle}>
                        {t('btn')}
                        <IconVideo />
                    </button>
                )}
            </div>
            {isShow && locale !== 'cn' && <EfDialogYoutube open={isShow} src={naYoutube} callback={closeCallback} />}
            {isShow && locale === 'cn' && <DialogVideo src="" callback={closeCallback} />}
        </div>
    );
};

// 日本
const TheCompCommonJP: FC = () => {
    const { t } = useLang('dp3.landing.Banner');
    const [isShow, setIsShow] = useState(false);
    const clickHandle = () => {
        setIsShow(true);
    };
    const closeCallback = () => {
        setIsShow(false);
    };

    return (
        <div
            id="dp3-teaser-A"
            className={`${css.thecomp} dp3-teaser-A dp3-teaser-full GtmModuleData-section`}
            data-section-id={'dp3-Banner'}
            data-section-title={t('title')}
        >
            <div className="kv-img">
                {/* <EditorVideo
                    pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1718805448259/t1.mp4"
                    h5="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1718805484420/t2.mp4"
                    poster="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718864450276/pv1.jpg"
                    posterH5="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718864500277/pv2.jpg"
                    autoPlay={true}
                    loop={true}
                    alt={t('title')}
                /> */}
                <EfImg
                    pc={'https://websiteoss.ecoflow.com/upload/image/1750730234585/pc_kv.jpg'}
                    h5={'https://websiteoss.ecoflow.com/upload/image/1750730234422/m_kv.jpg'}
                />
            </div>
            <div className="kv-info">
                <p className="kv-title">{t('title')}</p>
                <p className="kv-sub-title">{t('subTitle')}</p>
                <button className="kv-btn-video" onClick={clickHandle}>
                    {t('btn')}
                    <IconVideo />
                </button>
            </div>
            {isShow && <EfDialogYoutube open={isShow} src={jpYoutube} callback={closeCallback} />}
        </div>
    );
};

const TheComp: FC = () => {
    const { locale } = useRouter();
    if (locale === 'jp') {
        return <TheCompCommonJP></TheCompCommonJP>;
    }
    return <TheCompCommon></TheCompCommon>;
};

export default TheComp;
